import React, { useState } from 'react';
import NormalButton from '../../components/buttons/normalButton';
import ChangeEmailModal from '../../components/modals/changeEmail';
import ChangePasswordModal from '../../components/modals/changePassword';
import CreateNewUserModal from '../../components/modals/createNewUser';
import EditCardInformationModal from '../../components/modals/editCardInfo';
import InstructionModal from '../../components/modals/instructionModal';

const TestComponent = () => {
  const [visble, setVisible] = useState(true);
  const toggleModal = () => {
    setVisible(!visble);
  };
  return (
    <div style={{ height: '100%' }} className="test-component">
      <NormalButton type="primary" text="test button" />
      <InstructionModal
        visible={visble}
        isWarning
        title="Do you want to delete the selected card?"
        description="The information of this card will be deleted permanently and user cannot use this card anymore."
        onCancel={toggleModal}
      />
    </div>
  );
};

export default TestComponent;
